
document.addEventListener('DOMContentLoaded', function () {
    const allRegisterLinks = document.querySelectorAll('a[href*="criar-conta"]');
    const customerEmail = document.querySelector('#shopify_customer_email')?.value;
    const errorModal = document.querySelector('#error-message-modal');

    if (customerEmail) {
        allRegisterLinks.forEach((regLink) => {
            regLink.addEventListener('click', (e) => {
                e.preventDefault();
    
                errorModal.querySelector("#error-title").textContent = "Já está cadastrado";
    
                errorModal.show();
                setTimeout(() => {
                    errorModal.hide();
                    location.assign("/pages/a-minha-conta");
                }, 2000);
            })
        })
    }

    if (
        !location?.href?.includes("criar-conta") &&
        !location?.href?.includes("completar-perfil") &&
        !location?.href?.includes("vantagens")
    ) {
        const customerInfo = localStorage.getItem("customer-info");
        if (customerInfo) localStorage.removeItem("customer-info");
    }
})
